module.exports = __webpack_public_path__ + "static/img/VS.0b861a4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/VS.svg
// module id = mm99
// module chunks = 0